<script setup lang="ts">
import type { AppLocale } from "@/shared/config/i18n"
import { naiveThemeOverrides } from "@repo/design-tokens"
import { NConfigProvider, NDialogProvider, NMessageProvider } from "naive-ui"
import { computed, watchEffect } from "vue"
import { useI18n } from "vue-i18n"
import { useRoute } from "vue-router"
import { DEFAULT_LOCALE, naiveLocales } from "@/shared/config/i18n"

// Naive UI providers must wrap the tree so useMessage/useDialog work in pages.
// The locale pair tracks the UI language so Naive's own strings (pagination,
// table, pickers) switch with it instead of leaking English into the screen.
const { t, locale } = useI18n()
const naive = computed(() => naiveLocales[locale.value as AppLocale] ?? naiveLocales[DEFAULT_LOCALE])

// The tab title follows both the route and the active language.
const route = useRoute()
watchEffect(() => {
  const key = route.meta.titleKey
  document.title = key ? `${t(key)} · ${t("app.title")}` : t("app.title")
})
</script>

<template>
  <NConfigProvider
    :theme-overrides="naiveThemeOverrides"
    :locale="naive.locale"
    :date-locale="naive.dateLocale"
  >
    <NMessageProvider>
      <NDialogProvider>
        <RouterView />
      </NDialogProvider>
    </NMessageProvider>
  </NConfigProvider>
</template>
